import React from 'react';

const AppDrawerContext = React.createContext({});

export default AppDrawerContext;
